// extracted by mini-css-extract-plugin
export default {"container":"iGRhWOhc35efCd4M1iJH","table":"rs6eu273fPwhQJnJSWqE"};